import React, { Component } from 'react'
import { Col, Radio, Button, Input, Select, AutoComplete, Popover, Table, Modal, Icon, Row, Pagination } from 'antd'
import { app, api, config } from '../../app'
const Option = Select.Option

const RadioGroup = Radio.Group
const Search = Input.Search

// 组件导入

class ReTeamRegistrationInformationAudit extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        this.state = {
            componentRadio: '1',    //当前展示的是未审核还是已审核
            data: [     //table数据

            ],
            total: 0,
            page: 1,
            detailModal: false, //弹窗
            detailModalOp: 'adopt',
            detailInfo: {},
            prep_id: '',    //详情ID
            inputValue: '',   //搜索框内容
            noAdopt: '',  //不通过原因
            showImgModal: false,
            showImg: ''  //预览的图片
        }
        this.getTeamAuthorizeList()

    }

    componentDidMount() {

    }




    getTeamAuthorizeList = () => {  //获取授权信息审核列表
        app.post(api.TeamPrepAuditTeamAuthorizeList, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type: 1,
            page: 1
        }).then(res => {

            if (res.flag == 1) {
                this.setState({
                    data: res.data,
                    total: parseInt(res.total || 0)
                })

            } else {
                app.alert(res.msg, 'error', '45%')
                // this.setState({
                //     data: res.data,
                //     total: parseInt(total || 0)
                // })
            }
        })
    }


    choiceOption = (e) => {   //切换审核状态
        this.setState({
            page: 1
        })
        app.post(api.TeamPrepAuditTeamAuthorizeList, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type: e,
            page: 1
        }).then(res => {
            if (res.flag == 1) {
                this.setState({
                    data: res.data,
                    componentRadio: e,
                    total: parseInt(res.total || 0)
                })

            } else {
                app.alert(res.msg, 'error', '45%')

            }
        })
    }

    Details = (e, detailModalOp) => {   //打开信息详情弹窗

        let { data, detailInfo } = this.state
        data.forEach((i, v) => {
            if (i.id == e.id) {
                detailInfo.name = i.name
                detailInfo.authorize_name = i.authorize_name
                detailInfo.credit_code = i.credit_code
                detailInfo.issuing_unit = i.issuing_unit
                detailInfo.authorize_start_time = i.authorize_start_time
                detailInfo.authorize_end_time = i.authorize_end_time
                detailInfo.authorize_img = i.authorize_img
            }
        })
        this.setState({
            detailModal: true,
            prep_id: e.id,
            detailInfo: detailInfo,
            detailModalOp: detailModalOp
        })
    }

    detailModalCencel = () => {  //关闭信息详情弹窗
        this.setState({
            detailModal: false
        })
    }

    getInputValue = (e) => { //搜索栏内容
        this.setState({
            inputValue: e
        })
    }

    Search = () => { //搜索按钮

        let { inputValue, componentRadio } = this.state
        app.post(api.TeamPrepAuditTeamAuthorizeList, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type: componentRadio,
            search_val: inputValue,
            search_type: 'searchform_name',
            page: 1
        }).then(res => {
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')
                this.setState({
                    data: res.data,
                    total: parseInt(res.total || 0),
                    page: 1
                })

            } else {
                app.alert(res.msg, 'error', '45%')

            }
        })
    }


    adopt = () => {  //审核通过
        let { prep_id } = this.state
        app.post(api.TeamPrepAuditTeamAuthorizeAudit, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            id: prep_id,
            audit: 1
        }).then(res => {
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')
                this.setState({
                    detailModal: false,
                })
                this.getTeamAuthorizeList()
            } else {
                app.alert(res.msg, 'error', '45%')
            }
        })
    }


    noAdopt = () => {    //审核不通过
        let { prep_id, noAdopt } = this.state
        app.post(api.TeamPrepAuditTeamAuthorizeAudit, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            id: prep_id,
            audit: 2,
            detail: noAdopt
        }).then(res => {
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')
                this.setState({
                    detailModal: false,
                })
                this.getTeamAuthorizeList()

            } else {
                app.alert(res.msg, 'error', '45%')
            }
        })
    }

    getNoAdoptTitle = (e) => {
        this.setState({
            noAdopt: e.target.value
        })
    }


    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataSource = async (page = 1) => {
        await this.setState({ page })
        let { dataType, search_type, search_val } = this.state, params = {
            page,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type: 1
        }
        let { flag, data, msg, total } = await app.post(api.TeamPrepAuditTeamAuthorizeList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setState({
                data: data,
                total: parseInt(total || 0),
            })
        }
    }


    showImgModalOpen = (img) => {
        this.setState({
            showImgModal: true,
            showImg: img
        })
    }

    // 关闭图片弹窗
    showImgModalCencel = () => {
        this.setState({
            showImgModal: false
        })
    }

    // 页面渲染区
    render() {
        let { data, detailInfo, total, page } = this.state
        // 未审核
        const columns = [
            {
                title: '队伍名称',
                width: 200,
                dataIndex: 'teamname',
                key: '1',
            },
            {
                title: '类型',
                width: 200,
                // dataIndex: 'type',
                key: '2',
                render: (record) => <div>
                    <p>{record.type == 1 ? '品牌授权' : '法人注册'}</p>
                </div>
            },
            {
                title: '法人代表',
                dataIndex: 'name',
                key: '3',
                width: 200,

            },
            {
                title: '信用编码',
                dataIndex: 'credit_code',
                key: '4',
                width: 100,

            },
            {
                title: '发证机关',
                dataIndex: 'issuing_unit',
                key: '5',
                width: 200,

            },
            {
                title: '上传时间',
                // dataIndex: 'audit_title',
                key: '6',
                width: 200,
                render: (record) => <div>
                    {/* {
                        console.log(record)
                    } */}

                    <p>{record.submit_time}</p>
                </div>

            },
            {
                title: '操作',
                key: 'operation',
                width: 200,
                height: 200,
                render: (record) => <div>
                    <div >
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.Details(record)}>详情</Button>

                    </div>
                    <div style={{ marginTop: 7 }}>
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.Details(record, 'adopt')}>通过</Button>
                    </div>
                    <div style={{ marginTop: 7 }} >
                        <Button style={{ color: 'red', width: 80, height: 30, borderColor: 'red' }} onClick={() => this.Details(record, 'noAdopt')}>不通过</Button>
                    </div>
                </div>,
            },
        ];
        // 已审核
        const columns2 = [
            {
                title: '队伍名称',
                width: 200,
                dataIndex: 'teamname',
                key: '11',
            },
            {
                title: '类型',
                width: 100,
                // dataIndex: 'type',
                key: '22',
                render: (record) => <div>
                    <p>{record.type == 1 ? '品牌授权' : '法人注册'}</p>
                </div>
            },
            {
                title: '法人代表',
                dataIndex: 'name',
                key: '33',
                width: 200,

            },
            {
                title: '信用编码',
                dataIndex: 'credit_code',
                key: '44',
                width: 200,

            },
            {
                title: '发证机关',
                dataIndex: 'issuing_unit',
                key: '55',
                width: 200,

            },
            {
                title: '上传时间',
                // dataIndex: 'audit_title',
                key: '66',
                width: 200,
                render: (record) => <div>
                    {/* {
                        console.log(record)
                    } */}

                    <p>{record.submit_time}</p>
                </div>

            },
            {
                title: '审核结果',
                // dataIndex: 'audit_title',
                key: '77',
                width: 200,
                render: (record) => <div>
                    {/* {
                        console.log(record)
                    } */}
                    <p>{record.admin_name}</p>
                    <p>{record.admin_audit == 0 ? '未审核' : (record.admin_audit == 1 ? '审核通过' : '审核不通过')}

                        <Popover content={record.detail} >
                            <span style={{ color: '#1890ff' }}>{record.admin_audit == '2' ? '查看原因' : ''}</span>
                        </Popover>
                    </p>
                    <p>{record.admin_time}</p>
                </div>

            },
            {
                title: '操作',
                key: 'operation2',
                width: 200,
                height: 200,
                render: (record) => <div>
                    <div >
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.Details(record)}>详情</Button>
                    </div>
                </div>,
            },
        ];
        return (
            <div className="teamApplication" style={{ padding: 30, backgroundColor: '#fff' }}>
                <h2>队伍注册信息审核</h2>
                {/* 头部操作栏 */}
                <div style={{ display: 'flex' }}>
                    <div>
                        审核状态：
                        <Select placeholder="请选择" style={{ width: 150 }} onSelect={(e) => this.choiceOption(e)} defaultValue="未审核">
                            <Option value="1" >未审核</Option>
                            <Option value="2">已审核</Option>
                        </Select>
                    </div>


                    <div style={{ paddingLeft: 50 }}>
                        {/* 审核状态： */}
                        <Select placeholder="请选择" style={{ width: 100 }} onSelect={(e) => this.choiceOption2(e)} defaultValue="队伍名称">
                            <Option value="teamname">队伍名称</Option>
                        </Select>

                        <AutoComplete
                            style={{ height: 50, width: 200 }}
                            // dataSource={memberList}
                            filterOption={(inputValue, option) =>
                                option.props.children.includes(inputValue)
                            }
                            onChange={this.getInputValue}
                            placeholder="输入关键词搜索"
                        />
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff' }} onClick={this.Search}>搜索</Button>
                    </div>

                </div>

                {/* table栏/未审核 */}
                {/* 如果当前需要展示的是已审核，那么当前组件隐藏 */}
                <div hidden={this.state.componentRadio == 2}>
                    <Table columns={columns} dataSource={data} scroll={{ y: 700 }}
                        rowKey={record => record.id}
                        pagination={false}
                        footer={() => {
                            return (
                                <Row hidden={data.length === 0}>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Pagination total={total} size="small" pageSize={20} current={page}
                                            showTotal={(total) => `总数量：${total}`}
                                            onChange={this.dataSource} />
                                    </Col>
                                </Row>
                            )
                        }} />

                </div>

                {/* table栏/已审核 */}
                {/* 如果当前需要展示的是未审核，那么当前组件隐藏 */}
                <div hidden={this.state.componentRadio == 1} style={{ background: '#fff' }}>
                    <Table columns={columns2} dataSource={data} scroll={{ y: 550 }}
                        rowKey={record => record.id}
                        pagination={false}
                        footer={() => {
                            return (
                                <Row hidden={data.length === 0}>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Pagination total={total} size="small" pageSize={20} current={page}
                                            showTotal={(total) => `总数量：${total}`}
                                            onChange={this.dataSource} />
                                    </Col>
                                </Row>
                            )
                        }} />
                </div>
                <p style={{ color: '#fb6519' }}>注：上传已注册登记信息，管理员审核通过后，队伍信息申请成功</p>
                {/* 信息详情 */}
                <Modal visible={this.state.detailModal} width={1200} footer={null} onCancel={this.detailModalCencel} centered={true}>
                    <div style={{ paddingLeft: 300 }}>
                        <h3><Icon type="" style={{ color: '#48a7ff' }} />查看详情信息</h3>
                        <p>
                            <span>法人代表</span>
                            <span style={{ marginLeft: 50 }}>{detailInfo.name}</span>
                        </p>
                        <p>
                            <span>注册名称</span>
                            <span style={{ marginLeft: 50 }}>{detailInfo.authorize_name}</span>
                        </p>
                        <p>
                            <span>信用编码</span>
                            <span style={{ marginLeft: 50 }}>{detailInfo.credit_code}</span>
                        </p>
                        <p>
                            <span>发证机关</span>
                            <span style={{ marginLeft: 50 }}>{detailInfo.issuing_unit}</span>
                        </p>
                        <p>
                            <span>营业期限</span>
                            <span style={{ marginLeft: 50 }}>{detailInfo.authorize_start_time = '0000-00-00' && detailInfo.authorize_end_time == '0000-00-00' ? '长期' : detailInfo.authorize_start_time + '~' + detailInfo.authorize_end_time} </span>
                        </p>
                        <div style={{ display: 'flex' }}>
                            <span>注册证明</span>
                            <div style={{ marginLeft: 50 }}>
                                <img src={config.imgUrl + detailInfo.authorize_img} alt="" onClick={() => this.showImgModalOpen(detailInfo.authorize_img)} style={{ cursor: 'pointer', height: 300 }} />
                            </div>
                        </div>
                        <Modal visible={this.state.showImgModal} width={1200} footer={null} onCancel={this.showImgModalCencel} centered={true}>
                            <img src={config.imgUrl + this.state.showImg} alt="" style={{ width: '100%' }} />

                            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 100 }}>
                                <Button style={{ width: 200 }} onClick={this.showImgModalCencel}>关闭</Button>
                            </div>
                        </Modal>
                        <div hidden={this.state.detailModalOp != 'noAdopt'} style={{ display: 'flex', marginTop: 30 }}>
                            <span>不通过原因</span>
                            <textarea name="" id="" rows="10" style={{ height: '100%', width: 500, resize: 'none', borderRadius: 10, marginLeft: 40 }} onChange={this.getNoAdoptTitle} name="reasonTitle"></textarea>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 200 }}>
                        <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.adopt} hidden={this.state.detailModalOp != 'adopt'}>通过</Button>
                        <Button style={{ width: 200, color: 'red', marginRight: 40 }} onClick={this.noAdopt} hidden={this.state.detailModalOp != 'noAdopt'}>不通过</Button>
                        <Button style={{ width: 200 }} onClick={this.detailModalCencel}>关闭</Button>
                    </div>
                </Modal>
            </div>

        )
    }
}



export default ReTeamRegistrationInformationAudit



// WEBPACK FOOTER //
// ./src/routes/review/ReTeamRegistrationInformationAudit.jsx